<template>
  <v-scroll-y-transition hide-on-leave leave-absolute>
    <div v-if="step === surveyStepperStep" :key="`step---${step}`" class="app-survey-step__content">
      <slot />
    </div>
  </v-scroll-y-transition>
</template>

<script>
export default {
  name: 'AppSurveyStep',
  inject: ['surveyStepper'],
  props: {
    step: {
      type: Number,
      required: true
    }
  },
  computed: {
    surveyStepperStep () {
      return this.surveyStepper.step
    }
  }
}
</script>
